"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositiveNegativeInProgress = void 0;
exports.createMicrobiologicalProcedures = createMicrobiologicalProcedures;
const shared_1 = require("../../shared");
const messages_1 = require("./messages");
const queries_1 = require("../queries");
const messages = {
    microbiologicalProcedures: {
        id: "dashboard.microbiological_procedures",
        defaultMessage: "Mikrobiológiai vizsgálatok"
    },
    cmv: {
        id: "dashboard.cmv",
        defaultMessage: "CMV"
    },
    ebvSerology: {
        id: "dashboard.ebv_serology",
        defaultMessage: "EBV"
    },
    toxoplasmaSerology: {
        id: "dashboard.toxopasma_serology",
        defaultMessage: "Toxoplazma"
    },
    varicellaSerology: {
        id: "dashboard.varicella_serology",
        defaultMessage: "Varicella"
    },
    hsv1Serology: {
        id: "dashboard.hsv1_serology",
        defaultMessage: "HSV1"
    },
    hsv2Serology: {
        id: "dashboard.hsv2_serology",
        defaultMessage: "HSV2"
    },
    syphilisScreening: {
        id: "dashboard.syphilis_screening",
        defaultMessage: "Szifilisz szűrés"
    },
    hivScreening: {
        id: "dashboard.hiv_screening",
        defaultMessage: "HIV szűrés"
    },
    hbcAbIgg: {
        id: "dashboard.hbc_ab_igg",
        defaultMessage: "HBc-Ab IgG"
    },
    hbsAb: {
        id: "dashboard.hbs_ab",
        defaultMessage: "HBs-Ab"
    },
    hbsAg: {
        id: "dashboard.hbs_ag",
        defaultMessage: "HBs-Ag"
    },
    hbcAbIgm: {
        id: "dashboard.hbc_ab_igm",
        defaultMessage: "HBc-Ab IgM"
    },
    hcvScreening: {
        id: "dashboard.hcv_screening",
        defaultMessage: "HCV szűrés"
    }
};
var PositiveNegativeInProgress;
(function (PositiveNegativeInProgress) {
    PositiveNegativeInProgress["POSITIVE"] = "POSITIVE";
    PositiveNegativeInProgress["NEGATIVE"] = "NEGATIVE";
    PositiveNegativeInProgress["IN_PROGRESS"] = "IN_PROGRESS";
})(PositiveNegativeInProgress || (exports.PositiveNegativeInProgress = PositiveNegativeInProgress = {}));
const groups = [
    {
        variant: "dark",
        label: messages_1.messages.completedExaminations,
        predicate: (event) => event !== undefined
    }
];
const values = [
    { label: messages.cmv, query: queries_1.queries.cmv },
    { label: messages.ebvSerology, query: queries_1.queries.ebvSerology },
    { label: messages.toxoplasmaSerology, query: queries_1.queries.toxoplasmaSerology },
    { label: messages.varicellaSerology, query: queries_1.queries.varicellaSerology },
    { label: messages.hsv1Serology, query: queries_1.queries.hsv1Serology },
    { label: messages.hsv2Serology, query: queries_1.queries.hsv2Serology },
    { label: messages.syphilisScreening, query: queries_1.queries.syphilisScreening },
    { label: messages.hivScreening, query: queries_1.queries.hivScreening },
    { label: messages.hcvScreening, query: queries_1.queries.hcvScreening },
    { label: messages.hbcAbIgg, query: queries_1.queries.hbcAbIgg },
    { label: messages.hbsAb, query: queries_1.queries.hbsAb },
    { label: messages.hbsAg, query: queries_1.queries.hbsAg },
    { label: messages.hbcAbIgm, query: queries_1.queries.hbcAbIgm }
];
function createMicrobiologicalProcedures(intl, { events }) {
    const { formatMessageMap } = intl;
    const list = (0, shared_1.createGroupList)(intl, {
        events,
        groups,
        values,
        formatValue: (value) => formatMessageMap(shared_1.positiveNegativeInProgressMessages, value)
    });
    const content = (0, shared_1.createSectionContent)([list]);
    return (0, shared_1.createSection)(intl, {
        label: messages.microbiologicalProcedures,
        content
    });
}
